import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Flame, Trophy } from 'lucide-react';

const ProtocolComplete = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentStreak = location.state?.currentStreak;
  const longestStreak = location.state?.longestStreak;
  const hasStreak = typeof currentStreak === 'number' && currentStreak > 0;

  const handleContinue = () => {
    navigate('/dashboard');
  };

  // Allow Enter or Arrow keys to trigger the continue button
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (['Enter', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
        event.preventDefault();
        handleContinue();
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center relative overflow-hidden">

      {/* Completion Message - Restored */}
      <div className="text-center text-white max-w-4xl mx-auto px-6">

        {/* MHB Logo/Text in center */}
        <div className="mb-10">
          <h1 className="text-6xl md:text-8xl font-light tracking-wider mb-4">
            MHB
          </h1>
          <h2 className="text-2xl md:text-3xl font-light tracking-wide text-emerald-400">
            Protocol Complete
          </h2>
        </div>

        <div className="space-y-8 mb-12">
          <p className="text-xl md:text-2xl font-light leading-relaxed">
            You have grown so much, if I could reach through the screen to hug you I would. Please do it for me, grab your arms and give yourself such a loving embrace. Rub your arms up and down. Enjoy a supportive pat on your shoulders.
          </p>

          <p className="text-lg md:text-xl font-light leading-relaxed">
            You are doing all the right things.
          </p>

          <p className="text-lg md:text-xl text-emerald-300 font-light leading-relaxed">
            You are now completely updated to a state of the art Modern Human Being.
          </p>
        </div>

        {/* Continue Button */}
        <button
          data-testid="protocol-complete-continue-btn"
          onClick={handleContinue}
          className="px-12 py-4 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl hover:from-emerald-700 hover:to-teal-700 transition-all font-medium text-lg shadow-2xl"
        >
          Go Get Em' Tiger!
        </button>

        <p className="text-sm text-gray-400 mt-6">
          ✨ Your daily practice creates ripples of positive change ✨
        </p>

        {/* Streak Counter - subtle, at the bottom */}
        {hasStreak && (
          <div
            data-testid="ritual-streak-card"
            className="mt-8 flex items-center justify-center gap-2 text-gray-400"
          >
            <Flame className="w-4 h-4 text-orange-400/80" strokeWidth={1.75} />
            <span data-testid="ritual-streak-count" className="text-sm font-medium tabular-nums">
              {currentStreak}
            </span>
            <span className="text-sm font-light">
              day{currentStreak === 1 ? '' : 's'} in a row
            </span>
            {typeof longestStreak === 'number' && longestStreak > 0 && (
              <span data-testid="ritual-longest-streak" className="text-xs text-gray-500">
                {currentStreak >= longestStreak && currentStreak > 1
                  ? '· New personal best!'
                  : `· Best: ${longestStreak}`}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProtocolComplete;
